'use client';

import { c as _c } from "react/compiler-runtime";
import './Contents.scss';
import { cn } from '@core/utils';
import { EditorContent } from '@tiptap/react';
import { useContext } from 'react';
import { CustomEditorContext } from '.';
export interface CustomEditorContentsProps {
  className?: string;
}
export const Contents = t0 => {
  const $ = _c(5);
  const {
    className
  } = t0;
  const {
    editor
  } = useContext(CustomEditorContext);
  let t1;
  if ($[0] !== className) {
    t1 = cn("editor-container", "flex flex-col overflow-auto p-16 text-left text-Gray-900", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = editor as Parameters<typeof EditorContent>[number]['editor'];
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <EditorContent className={t1} editor={t2} />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};